export interface ChangePasswordForm {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export enum ChangePasswordErrors {
  INVALID_PASSWORD = "InvalidPasswordException",
}
